// Custom BF Components
// This component also serves the bfcomp component

<template>
  <component
    :is="comp.html ? 'html-renderer-old' : 'vue-form-generator'"
    v-if="bfComponentReady"
    :ref="'comp_'+_uid"
    :key="'comp_'+_uid"
    class="bf-comp"
    :template="theTemplate"
    :schema="theSchema"
    :model="theModel"
    :options="formOptions"
    :value="value"
    :app="$store.state.site.content.app"
    :params="$store.state.site.content.params"
    @validated="validated"
  >
  </component>
</template>

<script>
    export default {
        props: [name],
        name: 'BfComponent',
        mixins: [VueFormGenerator.abstractField],
        methods: {
            validate: async function () {
                this.errors = [];
                this.sectionErrors = {};
    
                try {
                    await this.$refs['comp_'+ this._uid].validate();
                    this.eventBus.$emit("field-validated", true, [], this.fieldUID);
                } catch (err) {
                    this.eventBus.$emit("field-validated", false, err, this.fieldUID);
                }
            },
            validated() {
                this.$emit("errors-updated", arguments[2].errors);
            },
            
            // Async methods to handle lifecycle actions (Vue 2 lifecycle hooks can't be async)
            async runBeforeMount() {
                try {
                await this.dispatchLifecycleActions('onBeforeMount', '_bfHasFiredBeforeMount');
                } catch (err) {
                    console.error('[bfcomponent] Error in onBeforeMount:', err);
                } finally {
                    // Mark component as ready to render even if onBeforeMount fails
                this.bfComponentReady = true;
                }
                
                // Wait for Vue to render the DOM before calling onMount
                // This ensures the component template is rendered and $refs are available
                await this.$nextTick();
                await this.runMounted();
            },
            
            async runMounted() {
                try {
                await this.dispatchLifecycleActions('onMount', '_bfHasFiredOnMount');
                } catch (err) {
                    console.error('[bfcomponent] Error in onMount:', err);
                }
            },
            
            async runBeforeDestroy() {
                await this.dispatchLifecycleActions('onBeforeDestroy', '_bfHasFiredBeforeDestroy');
            },
            
            async runDestroyed() {
                await this.dispatchLifecycleActions('onDestroyed', '_bfHasFiredDestroyed');
            },
            
            async runUpdated() {
                this._bfIsUpdating = true;
                await this.dispatchLifecycleActions('onUpdated', '_bfHasFiredUpdated');
                // Reset the flag after a tick to allow future updates
                this.$nextTick(() => {
                    this._bfIsUpdating = false;
                    this._bfHasFiredUpdated = false;
                });
            },
            
            // Helper method to dispatch lifecycle namedActions
            async dispatchLifecycleActions(lifecycleHookName, flagName) {
                // Check if this lifecycle hook has already fired
                if (this[flagName]) return;
                
                const name = this.$attrs.name || this.schema.name;
                const def = this.$store.getters['components'](name);
                
                // Support both 'on' prefix and plain hook name (e.g., 'onMount' and 'mounted')
                const namedActionKey = lifecycleHookName;
                const altKey = lifecycleHookName.replace(/^on/, '').replace(/^(.)/, (m) => m.toLowerCase()); // onMount -> mount
                
                const actionsDef = _.get(this.comp, ['namedActions', namedActionKey]) || 
                                   _.get(def, ['namedActions', namedActionKey]) ||
                                   _.get(this.comp, ['namedActions', altKey]) || 
                                   _.get(def, ['namedActions', altKey]);
                
                if (!actionsDef) return;
                
                this[flagName] = true;
                
                var actionsArray = [];
                Array.isArray(actionsDef) ? actionsArray = _.cloneDeep(actionsDef) : actionsArray.push(_.cloneDeep(actionsDef));
                
                // Include Vue _uid so two instances mounting in the same ms
                // never share an idThread (Date.now() alone collides and orphans
                // one ACTIONS_QUEUE waiter → bfComponentReady stuck false).
                var idThread = Date.now() + '_' + this._uid;
                
                for (var i = 0, len = actionsArray.length; i < len; i++) {
                    actionsArray[i].options ? null : actionsArray[i].options = {};
                    actionsArray[i].idThread = idThread;
                    // Provide component schema to lifecycle actions for function contexts
                    actionsArray[i].options._componentSchema = this.theSchema;
                    actionsArray[i].schema = this.theSchema;
                }
                
                // Dispatch and AWAIT completion (ACTIONS_QUEUE now returns a Promise)
                await this.$store.dispatch('ACTIONS_QUEUE', {
                    actions: actionsArray,
                    insert: true,
                    idThread: idThread
                });
            }
        },
        computed: {
            comp: function() { 
                let name = this.$attrs.name || this.schema.name
                let component = this.$attrs.source || _.get(this, 'schema.source') || this.$store.getters['components'](name)
                if (!component ) {
                    // Don't call BF.errorThrow here - would cause infinite loop in computed property
                    // Just return the error display HTML
                    return {
                            "html": `<h4 style="padding: 8px;color: red;background-color: #ffdede;">Component <b style="color:black;">'${name}'</b> not found</h4>`
                        }
                }
                // Does the scehma have prop fields or schema.foields to override?
                // debugger
                let fields = this.$attrs.fields || _.get(this, 'schema.fields') 
                fields ? component.comp.fields = fields : null
                return component.comp
            },
            theSchema: function(){
                return Object.assign({} ,this.comp, this.$attrs, this.schema ) // this may break calcs
            },
            theFields: function(){
                return { fields:this.comp.fields }
            },
            theTemplate: function() { 
                let divWrapper = 'divWrapper' in this.comp ? this.comp.divWrapper : false
                return divWrapper ? `<div class="bfcomp-wrapper" style="width: 100%;">${this.comp.html}</div>` : this.comp.html
                // return '<div class="bfcomp-wrapper">' + this.comp.html + '</div>'
            },
            
            value: function(){return null},
            
            theModel: function() { 
                return this.$attrs.modelSource  || this.model || this.comp.modelDev }
        },

        errorCaptured(err, vm, info) {
            console.log(`Component errorCaptured: ${err.toString()}\ninfo: ${info}`);
            return false;
        },
        
        // Lifecycle hooks with namedActions support
        beforeMount() {
            // Run onBeforeMount actions and wait for completion before rendering
            this.runBeforeMount();
        },
        
        mounted() {
            // onMount actions are called from runBeforeMount() after DOM is rendered
            // No action needed here - Vue's mounted hook fires after runBeforeMount completes
        },
        
        beforeDestroy() {
            // Run onBeforeDestroy actions and wait for completion before destroying
            this.runBeforeDestroy();
        },
        
        destroyed() {
            // Run onDestroyed actions after component is destroyed
            this.runDestroyed();
        },
        
        updated() {
            // Run onUpdated actions (only once per update cycle)
            if (!this._bfIsUpdating) {
                this.runUpdated();
            }
        },

        data() {
            return {
                sectionErrors: [],
                bfComponentReady: false,  // Controls initial render (set to true after onBeforeMount completes)
                _bfHasFiredBeforeMount: false,
                _bfHasFiredOnMount: false,
                _bfHasFiredBeforeDestroy: false,
                _bfHasFiredDestroyed: false,
                _bfHasFiredUpdated: false,
                _bfIsUpdating: false
            }
        }
        
    }
</script>

<style>
    .bf-comp {
        width: 100%
    };
</style>

                             
